'use client';
import { useState } from 'react';
import * as S from './styles.ts';
import { H2 } from '@template/components';
import { Form } from '@template/components';
import { UniversalLink } from '@template/components';

export const SupportForm = () => {
  const [formValue, setFormValue] = useState<Record<string, string>>({
    name: '',
    email: '',
    phone: '',
    message: '',
    type: '',
  });
  const [errors, setErrors] = useState<any>(formValue);
  const [loading, setLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const apiUrl = 'https://www.yay.com';
  const apiSuffix = '/svc/contact-us';
  const apiEndpoint = `${apiUrl}${apiSuffix}`;

  const sendData = async ({
    name,
    email,
    phone,
    message,
    type,
  }: Record<string, string>) => {
    setLoading(true);
    try {
      const request = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
          type,
        }),
      });
      const response = await request.json();
      if (response.message === 'Success') {
        setSuccessMessage(
          `Thanks! Your message has been received, your ticket number is ${response.ticket_number}`
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data: Record<string, any>) => {
    await sendData(data);
  };

  return (
    <>
      {!successMessage ? (
        <Form
          value={formValue}
          onChange={setFormValue}
          submit={{
            text: 'Submit',
            onSubmit: handleSubmit,
            loading: loading,
          }}
          inputs={[
            {
              label: 'Full Name',
              name: 'name',
              error: errors.name,
              span: 6,
              required: true,
            },
            {
              label: 'Email',
              name: 'email',
              placeholder: 'name@example.com',
              validation: {
                regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                error: 'Please enter a valid email address',
              },
              error: errors.email,
              span: 6,
              required: true,
            },
            {
              label: 'Phone Number',
              name: 'phone',
              prefix: '+44',
              placeholder: '0207 123 4567',
              error: errors.phone,
              span: 12,
            },
            {
              label: 'Enquiry type',
              name: 'type',
              span: 12,
              type: 'select',
              placeholder: 'Select a type...',
              options: [
                {
                  label: 'Need a little help',
                  key: 'Need a little help',
                },
                {
                  label: 'Quick question',
                  key: 'Quick question',
                },
                {
                  label: 'Have a concern',
                  key: 'Have a concern',
                },
                {
                  label: 'Report abuse',
                  key: 'Report abuse',
                },
              ],

              required: true,
            },
            {
              label: 'Message',
              name: 'message',
              error: errors.message,
              placeholder: 'Enter a description...',
              span: 12,
              type: 'textarea',
              required: true,
            },
          ]}
          checkbox={{
            name: 'Privacy policy',
            label: (
              <>
                You agree to our friendly{' '}
                <UniversalLink styled href='/about/privacy'>
                  Privacy Policy
                </UniversalLink>
              </>
            ),

            checked: checked,
            onChange: handleCheckboxChange,
          }}
        />
      ) : (
        <S.SuccessMessageContainer>
          <H2>{successMessage}</H2>
        </S.SuccessMessageContainer>
      )}
    </>
  );
};
